import {
  USE_CASE,
  USER_ROLE,
} from '@trustero/trustero-api-web/lib/account/account_pb'

export enum LoginProviders {
  GOOGLE = 'Google',
  AUTH0 = 'Auth0', //Auth0 was acquired by Okta
  OKTA = 'Okta',
  ONELOGIN = 'OneLogin',
  MICROSOFT = 'Microsoft',
  ENTRA = 'Entra',
  PINGONE = 'PingOne',
  ENTRAIDSSO = 'Enterprise SSO',
}

export type AuthorizationComponentProps = {
  login: ({
    accessToken,
    accountId,
    email,
    useCase,
  }: {
    accessToken: string
    accountId?: string
    email?: string
    redirectUrl: string
    useCase: USE_CASE
    role: USER_ROLE
  }) => void
  setErrorMsg?: React.Dispatch<React.SetStateAction<string>>
  setIsRedirecting?: React.Dispatch<React.SetStateAction<boolean>>
}

export const getLastLogin = (): LoginProviders | null => {
  const stored = localStorage.getItem('lastlogin')
  if (stored === null) {
    return null
  }
  const validProviders = Object.values(LoginProviders)
  if (validProviders.includes(stored as LoginProviders)) {
    return stored as LoginProviders
  }
  return null
}

export const setLastLogin = (lastLogin: LoginProviders): void => {
  localStorage.setItem('lastlogin', lastLogin)
}

export const clearLastLogin = (): void => {
  localStorage.removeItem('lastlogin')
}
